<template>
  <div class="container mt-150">
    <div class="row">
      <div class="col-12">
        <div class="card mt-4">
          <div class="card-body">
            <h5 class="mb-4">
              <i class="fas fa-box-open mr-2" />กรุณากรอกข้อมูลสินค้า
            </h5>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>ลิงก์สินค้า:</label>
                  <div class="input-group">
                    <input
                      v-model="productUrl"
                      type="text"
                      class="form-control"
                      placeholder="วางลิงก์สินค้าที่นี่"
                    >
                    <div class="input-group-append">
                      <b-button
                        variant="primary"
                        :disabled="!productUrl"
                        @click="fetchProductDetails"
                      >
                        <i class="fas fa-search mr-1" />ค้นหา
                      </b-button>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>รหัสสินค้า:</label>
                  <input
                    v-model="productId"
                    type="text"
                    class="form-control"
                    placeholder="วางรหัสสินค้าที่นี่"
                  >
                </div>

                <div class="form-group">
                  <label>ราคา:</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">฿</span>
                    </div>
                    <input
                      v-model="price"
                      type="number"
                      class="form-control"
                      placeholder="0.00"
                    >
                  </div>
                </div>

                <div class="form-group">
                  <label>จำนวน:</label>
                  <div class="d-flex align-items-center">
                    <b-button
                      variant="outline-primary"
                      :disabled="quantity <= 1"
                      @click="decreaseQuantity"
                    >
                      <i class="fas fa-minus" />
                    </b-button>
                    <input
                      v-model="quantity"
                      type="number"
                      class="form-control mx-2 text-center"
                      style="width: 80px"
                    >
                    <b-button
                      variant="outline-primary"
                      @click="increaseQuantity"
                    >
                      <i class="fas fa-plus" />
                    </b-button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>สี:</label>
                      <input
                        v-model="color"
                        type="text"
                        class="form-control"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>ขนาด:</label>
                      <input
                        v-model="size"
                        type="text"
                        class="form-control"
                      >
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>สินค้าจากเว็บ:</label>
                  <select
                    v-model="website"
                    class="form-control"
                  >
                    <option value="">
                      เลือกเว็บไซต์
                    </option>
                    <option value="taobao">
                      Taobao
                    </option>
                    <option value="1688">
                      1688
                    </option>
                    <option value="tmall">
                      Tmall
                    </option>
                    <option value="other">
                      อื่นๆ
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>รูปภาพสินค้า:</label>
                  <div
                    class="image-preview-container mb-3"
                    :class="{ 'has-image': previewImages.length > 0 }"
                  >
                    <div
                      v-if="previewImages.length === 0"
                      class="drop-zone"
                      @click="triggerFileInput"
                    >
                      <i class="fas fa-cloud-upload-alt fa-2x mb-2" />
                      <p>คลิกเพื่ออัพโหลดรูปภาพ</p>
                    </div>
                    <div
                      v-else
                      class="preview-grid"
                    >
                      <div
                        v-for="(image, index) in previewImages"
                        :key="index"
                        class="preview-item"
                      >
                        <img
                          :src="image"
                          class="preview-image"
                          @click="showPicture(image)"
                        >
                        <button
                          class="remove-image"
                          @click.prevent="removeImage(index)"
                        >
                          <i class="fas fa-times" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <input
                    ref="fileInput"
                    type="file"
                    class="d-none"
                    accept="image/*"
                    multiple
                    @change="handleFileUpload"
                  >
                </div>

                <div class="form-group">
                  <label>หมายเหตุ:</label>
                  <textarea
                    v-model="note"
                    class="form-control"
                    rows="4"
                    placeholder="รายละเอียดเพิ่มเติม..."
                  />
                </div>
              </div>
            </div>

            <div class="text-right mt-4">
              <b-button
                variant="light"
                class="mr-2"
              >
                <i class="fas fa-times mr-1" />ยกเลิก
              </b-button>
              <b-button
                variant="success"
                @click="submitForm"
              >
                <i class="fas fa-save mr-1" />บันทึกข้อมูล
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vue-image-lightbox-carousel
      ref="lightbox"
      :show="showLightbox"
      :images="lightboxImages"
      :show-caption="false"
      @close="closeBox"
    />
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'

export default {
  components: {
    BButton,
    VueImageLightboxCarousel,
  },
  data() {
    return {
      productUrl: '',
      productId: '',
      price: 0,
      quantity: 1,
      color: '',
      size: '',
      website: '',
      note: '',
      previewImages: [],
      showLightbox: false,
      lightboxImages: [],
    }
  },
  methods: {
    increaseQuantity() {
      this.quantity++
    },
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const { files } = event.target
      Array.from(files).forEach(file => {
        const reader = new FileReader()
        reader.onload = e => {
          this.previewImages.push(e.target.result)
        }
        reader.readAsDataURL(file)
      })
    },
    removeImage(index) {
      this.previewImages.splice(index, 1)
    },
    showPicture(image) {
      this.showLightbox = true
      this.lightboxImages = [{ path: image }]
    },
    closeBox() {
      this.showLightbox = false
      this.lightboxImages = []
    },
    fetchProductDetails() {
      console.log('Fetching product details...')
    },
    submitForm() {
      console.log('Submitting form...')
    },
  },
}
</script>

<style lang="scss" scoped>
.image-preview-container {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 20px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;

  &.has-image {
    padding: 10px;
  }
}

.drop-zone {
  text-align: center;
  color: #666;
  cursor: pointer;

  &:hover {
    color: #333;
  }
}

.preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
  width: 100%;
}

.preview-item {
  position: relative;
  aspect-ratio: 1;

  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
  }

  .remove-image {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: darken(#dc3545, 10%);
    }
  }
}

.input-group {
  .form-control {
    border-right: 0;
  }

  .input-group-append .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

textarea.form-control {
  resize: vertical;
}
</style>
